import { useSuspenseQuery } from '@tanstack/react-query';
import { Button } from '@upme/ui/components/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@upme/ui/components/select';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@upme/ui/components/table';
import { useState } from 'react';
import { useDeleteCityLink, useUpsertCityLink } from '../mutations';
import { cityProviderLinksOptions, listProvidersOptions } from '../queries';

export function CityProvidersBlock({ cityId }: { cityId: string }) {
  const { data: links } = useSuspenseQuery(cityProviderLinksOptions(cityId));
  const { data: providers } = useSuspenseQuery(listProvidersOptions());
  const upsert = useUpsertCityLink(cityId);
  const del = useDeleteCityLink(cityId);
  const [selected, setSelected] = useState('');

  const linkedIds = new Set(links.map((l) => l.providerId));
  const available = providers.filter((p) => !linkedIds.has(p.id));

  return (
    <section className="space-y-3">
      <h2 className="text-lg font-semibold">Провайдеры платежей</h2>

      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Провайдер</TableHead>
            <TableHead>Приоритет</TableHead>
            <TableHead>Статус</TableHead>
            <TableHead className="text-right">Действия</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {links.map((l) => (
            <TableRow key={l.providerId}>
              <TableCell>{l.provider.name}</TableCell>
              <TableCell>{l.priority}</TableCell>
              <TableCell>{l.isActive ? 'активна' : 'выключена'}</TableCell>
              <TableCell className="text-right">
                <Button variant="destructive" size="sm" onClick={() => del.mutate(l.providerId)}>
                  Отвязать
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {available.length > 0 ? (
        <div className="flex items-end gap-2">
          <Select value={selected} onValueChange={setSelected}>
            <SelectTrigger className="w-64">
              <SelectValue placeholder="Выберите провайдера" />
            </SelectTrigger>
            <SelectContent>
              {available.map((p) => (
                <SelectItem key={p.id} value={p.id}>
                  {p.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <Button
            disabled={!selected}
            onClick={() =>
              upsert.mutate(
                { cityId, providerId: selected, priority: 0, isActive: true },
                { onSuccess: () => setSelected('') },
              )
            }
          >
            Привязать
          </Button>
        </div>
      ) : (
        <p className="text-sm text-muted-foreground">Все провайдеры уже привязаны.</p>
      )}
    </section>
  );
}
